import React, { useRef, useEffect } from 'react'
import './NewsContent.css'

const NewsContent = ({ newsContent }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current) return
    const imgs = ref.current.querySelectorAll('img')
    imgs.forEach((img) => {
      img.style.width = '500px'
      img.style.maxWidth = '100%'
      img.style.height = 'auto'
      img.style.display = 'block'
      img.style.marginBottom = '12px'
    })
  }, [newsContent])

  return (
    <div className="news-content-wrapper" ref={ref}>
      {newsContent.content.rendered && (
        <div dangerouslySetInnerHTML={{ __html: newsContent.content.rendered }} />
      )}
    </div>
  )
}

export default NewsContent
